import Product from "./Product";
import Mailbox from "./Mailbox";
import Alert from "./Alert";
import Button from "./Button";
import UserMenu from "./UserMenu";
import { useState } from "react";

interface Book {
  id: string;
  name: string;
}

interface Values {
  x: number;
  y: number;
}


const books: Book[] = [
  { id: "id-1", name: "JS for beginners" },
  { id: "id-2", name: "React basics" },
  { id: "id-3", name: "React Query overview" },
];

export default function App() {
  const [count, setCount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setCount(count + 1);
  };

  const toggleMessage = () => {
    setIsOpen(!isOpen);
  };

  const [values, setValues] = useState<Values>({ x: 0, y: 0 });

  const updateX = () => {
    setValues({
      ...values,
      x: values.x + 1,
});
  };
  const updateY = () => {
    setValues({
      ...values,
      y: values.y + 1,
});
  };

  return (
    <>
      <h1>Best selling</h1>
      <Product
        name="Tacos With Lime"
        imgUrl="https://images.pexels.com/photos/461198/pexels-photo-461198.jpeg?w=640"
        price={10.99}
      />
      <Product
        name="Fries and Burger"
        imgUrl="https://images.pexels.com/photos/70497/pexels-photo-70497.jpeg?w=640"
        price={14.29}
      />
      <Mailbox
        username="Dima"
        messages={["1"]} />
      <div> {[1, 2, 3].map((item, index) => {
        return <p key={index}>{item}</p>;
      })}
      </div>
      <>
      <h1>Books of the week</h1>
      <ul>
        {books.map((book) => (
          <li key={book.id}>{book.name}</li>
        ))}
      </ul>
      </>
      <Alert />
      <Alert type="success"  />
      <Alert type="error" />
      <>
      <Button variant="primary" text="Login" />
        <Button variant="secondary" text="Follow" />
        <UserMenu name="HiUser" />
      </>
      <button onClick={handleClick}>Clicked: {count}</button>
      <button onClick={toggleMessage}>
        {isOpen ? "Hide message" : "Show message"}
      </button>

      {isOpen && <p>🎉 Surprise! You toggled me.</p>}

      <div>
      <p>x: {values.x}, y: {values.y}</p>
      <button onClick={updateX}>Update x</button>
      <button onClick={updateY}>Update y</button>
    </div>
    </>
  );
}
